export default __webpack_public_path__ + "static/media/adect-logo.4a63095e.png";